import React, { useState } from "react";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import Modal from "@/ui/Modal/Modal";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import cls from "./styles.module.scss";

export default function Offer({ label }: { label?: React.ReactNode }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const sections = t("offer.sections", { returnObjects: true }) as {
    title: string;
    content: string[];
  }[];

  const footer = t("offer.footer", { returnObjects: true }) as {
    title: string;
    content: string[];
  };

  return (
    <>
      <button
        type="button"
        className={cn(cls.offer, { [cls.customLabel]: label })}
        onClick={() => setIsOpen(true)}
      >
        {label || (
          <>
            {t("offer.button.text")}{" "}
            <span className={cls.link}>{t("offer.button.link")}</span>
          </>
        )}
      </button>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <FlexColumn gap={16}>
          <Typography className={cls.offerTitle} variant="h6">
            {t("offer.title")}
          </Typography>

          {sections.map((section, index) => (
            <FlexColumn key={index}>
              {section.title && (
                <Typography variant="h6">{section.title}</Typography>
              )}

              {section.content.map((text, i) => (
                <Typography key={i} variant="body2">
                  {text}
                </Typography>
              ))}
            </FlexColumn>
          ))}

          <FlexColumn>
            <Typography variant="h6">{footer.title}</Typography>

            {footer.content.map((text, index) => (
              <Typography key={index} variant="body2">
                {text}
              </Typography>
            ))}
          </FlexColumn>
        </FlexColumn>
      </Modal>
    </>
  );
}
